import excelTable from "./excelTable";

export default {
    excelTable: excelTable
  }